import request from '../request';

const BASE_PATH = 'quickapp/v1/device-tokens';

export const registerDeviceToken = async (data) => {
  console.log('[API] ===== REGISTERING DEVICE TOKEN WITH BACKEND =====');
  console.log('[API] Request URL:', `${BASE_PATH}/register`);
  console.log('[API] Request data:', data);
  
  try {
    console.log('[API] Sending POST request...');
    const response = await request({
      method: 'POST',
      url: `${BASE_PATH}/register`,
      data,
      useBaseUrl2: true
    }, false);
    
    console.log('[API] Raw response:', response);
    const parsedData = JSON.parse(response.data);
    console.log('[API] ✅ Parsed response:', parsedData);
    console.log('[API] ✅ Device token registered successfully');
    return parsedData;
  } catch (error) {
    console.error('[API] ❌ Error registering device token:', error);
    console.error('[API] Error details:', error.message);
    throw error;
  }
};

export const getMyTokens = async () => {
  try {
    const response = await request({
      method: 'GET',
      url: `${BASE_PATH}/my-tokens`,
      useBaseUrl2: true
    }, false);
    
    const parsedData = JSON.parse(response.data);
    return parsedData;
  } catch (error) {
    console.error('Error fetching tokens:', error);
    throw error;
  }
};

export const deactivateToken = async (token) => {
  try {
    const response = await request({
      method: 'POST',
      url: `${BASE_PATH}/deactivate`,
      params: { token },
      useBaseUrl2: true
    }, false);
    
    const parsedData = JSON.parse(response.data);
    return parsedData;
  } catch (error) {
    console.error('Error deactivating token:', error);
    throw error;
  }
};

export const deactivateAllTokens = async () => {
  try {
    const response = await request({
      method: 'POST',
      url: `${BASE_PATH}/deactivate-all`,
      useBaseUrl2: true
    }, false);
    
    const parsedData = JSON.parse(response.data);
    return parsedData;
  } catch (error) {
    console.error('Error deactivating all tokens:', error);
    throw error;
  }
};

export const testNotification = async () => {
  console.log('[API] ===== SENDING TEST NOTIFICATION =====');
  console.log('[API] Request URL:', `${BASE_PATH}/test-notification`);
  
  try {
    console.log('[API] Sending POST request...');
    const response = await request({
      method: 'POST',
      url: `${BASE_PATH}/test-notification`,
      useBaseUrl2: true
    });
    
    console.log('[API] Raw response:', response);
    const parsedData = JSON.parse(response.data);
    console.log('[API] ✅ Parsed response:', parsedData);
    console.log('[API] ✅ Test notification sent successfully');
    return parsedData;
  } catch (error) {
    console.error('[API] ❌ Error sending test notification:', error);
    console.error('[API] Error details:', error.message);
    throw error;
  }
};

export const subscribeToTopic = async (topic) => {
  try {
    const response = await request({
      method: 'POST',
      url: `${BASE_PATH}/subscribe-topic`,
      params: { topic },
      useBaseUrl2: true
    }, false);
    
    const parsedData = JSON.parse(response.data);
    return parsedData;
  } catch (error) {
    console.error('Error subscribing to topic:', error);
    throw error;
  }
};

export const unsubscribeFromTopic = async (topic) => {
  try {
    const response = await request({
      method: 'POST',
      url: `${BASE_PATH}/unsubscribe-topic`,
      params: { topic },
      useBaseUrl2: true
    }, false);
    
    const parsedData = JSON.parse(response.data);
    return parsedData;
  } catch (error) {
    console.error('Error unsubscribing from topic:', error);
    throw error;
  }
};